import defaultAttributes from '../defaultAttributes';

const RectangleHorizontal = [
  'svg',
  defaultAttributes,
  [['rect', { x: '2', y: '6', width: '20', height: '12', rx: '2' }]],
];

export default RectangleHorizontal;
